// ─── Platform Dashboard Types & Formatters ───────────────────────────────────
// All mock data has been removed — the platform dashboard is wired to real
// APIs via @/services/platform-dashboard.service.ts. Only shared types and
// display helpers live here.

export type DateRange = '7d' | '30d' | '90d';
export type DashboardMode = 'ready' | 'loading' | 'error';

export type TrendPoint = {
  label: string;
  revenue: number;
  previousRevenue: number;
  tenants: number;
};

export type SplitPoint = { name: string; value: number; color: string };

export type ApprovalItem = {
  id: string;
  tenantName: string;
  requestType: string;
  businessType: 'Retail' | 'Restaurant';
  priority: 'High' | 'Medium' | 'Low';
  requestedAt: string;
  owner: string;
  status: 'Awaiting review' | 'Plan change' | 'Risk review';
};

export type TenantActivityItem = {
  id: string;
  tenantName: string;
  businessType: 'Retail' | 'Restaurant';
  status: 'Active' | 'Trial' | 'Pending' | 'Suspended';
  locations: number;
  lastActive: string;
  mrr: number;
  plan: string;
};

export type OperationalAlert = {
  id: string;
  title: string;
  detail: string;
  severity: 'critical' | 'warning' | 'info' | 'success';
  timestamp: string;
};

export type AuditEvent = {
  id: string;
  actor: string;
  action: string;
  subject: string;
  timestamp: string;
  severity: 'critical' | 'warning' | 'info' | 'success';
};

export type NotificationItem = {
  id: string;
  title: string;
  detail: string;
  timestamp: string;
};

// ─── KPI Card config ─────────────────────────────────────────────────────────

export type KpiTone = 'primary' | 'success' | 'warning' | 'danger';

export interface KpiItem {
  id: string;
  label: string;
  value: string;
  delta: string;
  tone: KpiTone;
  supporting: string;
}

// ─── Formatting helpers ──────────────────────────────────────────────────────

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  })
    .format(value)
    .replace(/\u20B9/u, 'Rs ');
}

export function formatNumber(value: number) {
  return new Intl.NumberFormat('en-IN').format(value);
}
